import { AZURE_STORAGE_URL } from '@/configs';
import { syncStorageIntoStateService } from '../services';
import { localStorageLabels } from '../constants';
import { version } from '../../../package.json';
import { deviceDetect } from 'react-device-detect';

export const hasKey = (object, key) => {
  return Object.keys(object).some(function (member) {
    return ~member.indexOf(key);
  });
};

export const getTenantId = () => {
  const tid = syncStorageIntoStateService(localStorageLabels.TID);
  let tenantId = tid ?? '';

  if (tenantId) return tenantId;

  tenantId = window.location.host.split('.')[1]
    ? window.location.host.split('.')[0]
    : '';

  if (
    tenantId === 'dplayer' ||
    tenantId === 'splayer' ||
    tenantId === 'player' ||
    tenantId === 'playerv1' ||
    tenantId === 'v1'
  )
    tenantId = '';

  return tenantId;
};

export const getGeneralPath = (tid) => AZURE_STORAGE_URL + tid + `/general/`;
export const getContentPath = (tid) => AZURE_STORAGE_URL + tid + `/contents/`;

export const deviceInfoWithAppVersion = () => {
  const deviceInfo = deviceDetect();
  return { ...deviceInfo, appVersion: version };
};
